import type { BookingMode } from "@fm/api";

interface CategoryWithVehicleModes {
  vehicles?: Array<{ id: string; booking_mode?: BookingMode }> | null;
}

/**
 * vehicle id -> effective booking mode, read from the category details the
 * widget already loads (`GET /categories/:id` lists each vehicle with its
 * effective `booking_mode`). A vehicle in no category is absent: the
 * inventory grid does not carry the mode, so it is unknown, not `instant`.
 * `request` wins if a vehicle appears with different modes.
 */
export function buildVehicleBookingModeMap(
  categories: CategoryWithVehicleModes[],
): Map<string, BookingMode> {
  const modes = new Map<string, BookingMode>();

  for (const category of categories) {
    for (const vehicle of category.vehicles ?? []) {
      if (!vehicle.booking_mode) continue;
      if (modes.get(vehicle.id) === "request") continue;
      modes.set(vehicle.id, vehicle.booking_mode);
    }
  }

  return modes;
}
